import { render, staticRenderFns } from "./ReferralManagementList.vue?vue&type=template&id=349e1cc3"
import script from "@/controllers/custom/referral/referral-management-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/referral/referral-management-list.js?vue&type=script&lang=js&external"
import style0 from "./ReferralManagementList.vue?vue&type=style&index=0&id=349e1cc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports